<template>
  <div class="card dashboard-widget active-user-widget">
    <div class="card-header d-flex justify-content-between">
      <span>USER</span>
      <span class="link-export" @click="exportData">Export</span>
      <div id="download-area" class="d-none"></div>
    </div>
    <div class="card-body">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="stat-block">
          <div class="stat-label">ACTIVE USERS</div>
          <div class="stat-value">
            <span>{{ activeUserStat.activeUser }}</span>
            <span class="changes positive" v-if="activeUserStat.activeUserTrend > 0">
              <font-awesome-icon class="changes-icon" icon="chevron-up"></font-awesome-icon>
              <span class="changes-value">(+{{ activeUserStat.activeUserTrend }}%)</span>
            </span>
            <span class="changes negative" v-else-if="activeUserStat.activeUserTrend < 0">
              <font-awesome-icon class="changes-icon" icon="chevron-down"></font-awesome-icon>
              <span class="changes-value">(-{{ activeUserStat.activeUserTrend }}%)</span>
            </span>
          </div>
          <div class="stat-value-unit">{{ activeUserStat.activeUserCompareToTotal }}% of total users</div>
        </div>
        <div class="stat-block">
          <div class="stat-label">NEW USERS</div>
          <div class="stat-value">
            <span>{{ activeUserStat.newUser }}</span>
            <span class="changes positive" v-if="activeUserStat.newUserTrend > 0">
              <font-awesome-icon class="changes-icon" icon="chevron-up"></font-awesome-icon>
              <span class="changes-value">(+{{ activeUserStat.newUserTrend }}%)</span>
            </span>
            <span class="changes negative" v-else-if="activeUserStat.newUserTrend < 0">
              <font-awesome-icon class="changes-icon" icon="chevron-down"></font-awesome-icon>
              <span class="changes-value">(-{{ activeUserStat.newUserTrend }}%)</span>
            </span>
          </div>
          <div class="stat-value-unit">{{ activeUserStat.newUserCompareToActive }}% of active users</div>
        </div>
        <div class="stat-block">
          <div class="stat-label">RETURN USERS</div>
          <div class="stat-value">
            <span>{{ activeUserStat.returnUser }}</span>
            <span class="changes positive" v-if="activeUserStat.returnUserTrend > 0">
              <font-awesome-icon class="changes-icon" icon="chevron-up"></font-awesome-icon>
              <span class="changes-value">(+{{ activeUserStat.returnUserTrend }}%)</span>
            </span>
            <span class="changes negative" v-else-if="activeUserStat.returnUserTrend < 0">
              <font-awesome-icon class="changes-icon" icon="chevron-down"></font-awesome-icon>
              <span class="changes-value">(-{{ activeUserStat.returnUserTrend }}%)</span>
            </span>
          </div>
          <div class="stat-value-unit">{{ activeUserStat.returnUserCompareToActive }}% of active users</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="chart-container">
            <b-button squared variant="outline-info" @click="checkedValue('users')" :class="{'active': !currentState}" id='changechart'>Daily Active Users </b-button>
            <b-button squared variant="outline-info" @click="checkedValue('time')" :class="{'active': currentState}" id='changechart'>Active Time</b-button>
            <div id='loadingactiveUser' :class="{'d-none': loadingState}">
            <div style="position: absolute; z-index: 10;">
              <img src='@/assets/images/ui_loading.png'>
            </div>
            </div>
            <div :class="{'d-none': dataChartState}">
              <v-chart :options="heatmap" :class="{'d-none': !currentState, 'v-hidden': loadingState }" id="heatmap-activetime" autoresize />
              <GChart class="g-chart" type="AreaChart" :data="activeUserHistoryChartData" :class="{'d-none': currentState}" :options="chartOptions"></GChart>
            </div>
            <div :class="{'d-none': !dataChartState}" >
              <div class="chart-nodata"><p class="txt-nodata">No data</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueECharts from 'vue-echarts';
import 'echarts/lib/chart/heatmap';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/axis';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/visualMap';
import { mapGetters, mapActions } from 'vuex';
import { GChart } from 'vue-google-charts';
import moment from 'moment';
import Vue from 'vue';
import { BButton } from 'bootstrap-vue';

const hours = [
  '12am',
  '1am',
  '2am',
  '3am',
  '4am',
  '5am',
  '6am',
  '7am',
  '8am',
  '9am',
  '10am',
  '11am',
  '12pm',
  '1pm',
  '2pm',
  '3pm',
  '4pm',
  '5pm',
  '6pm',
  '7pm',
  '8pm',
  '9pm',
  '10pm',
  '11pm',
];

// prettier-ignore
const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].reverse();

export default {
  name: 'active-user-widget',
  components: {
    GChart,
    'v-chart': VueECharts,
    'b-button': BButton,
  },
  props: {
    criteria: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentState: false,
      dataChartState: false,
      loadingState: true,
      chartOptions: {
        isStacked: true,
        title: 'Active users',
        height: 300,
        legend: { position: 'in' },
        chartArea: {
          left: 50,
          top: 50,
          right: 20,
          bottom: 50,
          width: '50%',
          height: '100%',
        },
        focusTarget: 'category',
        hAxis: { showTextEvery: 4 },
      },
      heatmap: {
        tooltip: {
          position: 'top',
        },
        animation: false,
        grid: {
          height: '75%',
          bottom: '0%',
          right: '20',
          top: '5%',
          left: '80',
        },
        xAxis: {
          type: 'category',
          data: hours,
          splitArea: {
            show: true,
          },
          axisLabel: {
            rotate: 40,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'category',
          data: days,
          splitArea: {
            show: true,
          },
          axisLine: {
            show: false,
          },
        },
        visualMap: {
          type: 'continuous',
          min: 0,
          max: 0,
          itemGap: 1,
          calculable: true,
          splitNumber: 7,
          realtime: false,
          orient: 'horizontal',
          itemHeight: 200,
          itemWidth: 25,
          range: [0, 0],
          bottom: '-5%',
          left: 'center',
          inRange: {
            color: ['#F2F2F2', '#3371ff'],
          },
          formatter: (value) => value,
        },
        series: [
          {
            type: 'heatmap',
            data: [],
          }
        ]
      }
    };
  },
  watch: {
    criteria: {
      handler: 'init',
      immediate: true,
    },
    activeUserDataHeatmap: {
      handler: 'heatmapChart',
      immediate: true,
    }
  },
  methods: {
    ...mapActions({
      loadActiveUserData: 'dashboard/loadActiveUserData',
      loadActiveUserDataHeatmap: 'dashboard/loadActiveUserDataHeatmap',
      loadExportData: 'dashboard/loadExportData',
    }),
    async init() {
      this.loadingState = false;
      await this.loadActiveUserData({
        criteria: this.criteria,
      });
      await this.loadActiveUserDataHeatmap({
        criteria: this.criteria,
      });
    },
    convertTime(ms) {
      const input = moment.duration(ms);
      if (input.as('hours') >= 1) return input.as('hours').toFixed(2);
      if (input.as('minutes') >= 1) return input.as('minutes').toFixed(2);
      return input.as('seconds');
    },
    convertUnit(ms) {
      const input = moment.duration(ms);
      if (input.as('hours') >= 1) return 'hour(s)';
      if (input.as('minutes') >= 1) return 'minute(s)';
      if (input.as('seconds') >= 1) return 'second(s)';
      return 'second';
    },
    heatmapChart() {
      if (this.activeUserDataHeatmap && this.activeUserDataHeatmap.length !== 0) {
        const parsedobj = JSON.parse(JSON.stringify(this.activeUserDataHeatmap));
        const datanew = parsedobj.activeTime;
        let arr2 = [];
        let maxactiveUserCount = 0;
        Object.keys(datanew).reverse().forEach((value, i) => {
          const activeUserCount = Object.values(datanew[value]).map((key) => [key.activeUserCount]);
          if (maxactiveUserCount <= Math.max.apply(null, activeUserCount)) {
            maxactiveUserCount = Math.max.apply(null, activeUserCount);
          }
          const test = Object.values(datanew[value]).map((key) => [key.hour, i, key.activeUserCount]);
          arr2 = arr2.concat(Object.values(test));
        });
        this.heatmap.series[0].data = arr2;
        this.heatmap.visualMap.range = [0, maxactiveUserCount];
        this.heatmap.visualMap.max = maxactiveUserCount;
        if (maxactiveUserCount === 0) {
          this.dataChartState = true;
        }
        this.loadingState = true;
      }
    },
    checkedValue(value) {
      if (value === 'users') {
        this.loadingState = false;
        window.dispatchEvent(new Event('resize'));
        this.currentState = false;
        setTimeout(() => { this.loadingState = true; }, 800);
      } else {
        this.currentState = true;
        this.heatmapChart();
      }
      const elmnt = document.querySelectorAll('[id=changechart]');
      elmnt[0].style.pointerEvents = 'none';
      elmnt[1].style.pointerEvents = 'none';
      setTimeout(() => {
        elmnt[0].style.pointerEvents = 'unset';
        elmnt[1].style.pointerEvents = 'unset';
      }, 800);
    },
    async exportData() {
      await this.loadExportData({
        criteria: this.criteria,
      });
    }
  },
  computed: {
    ...mapGetters({
      activeUserData: 'dashboard/activeUserData',
      activeUserStat: 'dashboard/activeUserStat',
      activeUserHistory: 'dashboard/activeUserHistory',
      activeUserDataHeatmap: 'dashboard/activeUserDataHeatmap',
    }),
    activeUserHistoryChartData() {
      const { criteria } = this;
      let header = ['Date', 'New users', 'Return users'];
      let dateFormat = '';
      if (criteria) {
        if (criteria.time.granularity === 'month') {
          header = ['Month', 'New users', 'Return users'];
          dateFormat = 'M/YY';
        } else if (criteria.time.granularity === 'day') {
          header = ['Date', 'New users', 'Return users'];
          dateFormat = 'D/M/YY';
        } else if (criteria.time.granularity === 'hour') {
          header = ['Hour', 'New users', 'Return users'];
          dateFormat = 'HH:mm';
        }
      }
      if (this.activeUserHistory && this.activeUserHistory.length !== 0) {
        const dataList = this.activeUserHistory.map((obj) => [moment(obj.date).format(dateFormat), obj.newUser, obj.returnUser]);
        Vue.set(this, 'dataChartState', false);
        return [header, ...dataList];
      }
      return [header, ['No data', 0, 0]];
    },
  },
};
</script>
<style lang="scss" scoped>
.echarts {
  width: 100%;
  height: 350px;
}
.chart-nodata{
  height: 290px;
  opacity: 0.5;
  display: flex;
  justify-content: center;
}
.txt-nodata{
  margin-top: auto;
  margin-bottom: auto;
}
.toggle__button {
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
}
.toggle__button input[type='checkbox'] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}
.toggle__button .toggle__switch {
  display: inline-block;
  height: 12px;
  border-radius: 6px;
  width: 40px;
  background: #9ca8b6;
  box-shadow: inset 0 0 1px #bfcbd9;
  position: relative;
  margin-left: 10px;
  transition: all 0.25s;
}

.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
  content: '';
  position: absolute;
  display: block;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  left: 0;
  top: -3px;
  transform: translateX(0);
  transition: all 0.25s cubic-bezier(0.5, -0.6, 0.5, 1.6);
}

.toggle__button .toggle__switch::after {
  background: #4d4d4d;
  box-shadow: 0 0 1px #666;
}
.toggle__button .toggle__switch::before {
  background: #4d4d4d;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
  opacity: 0;
}
.toggle__button .toggle__switch.active::after {
  right: 0px;
  left: unset;
  background: #3371ff;
}
#loadingactiveUser{
    position: absolute;
    width: 100%;
    height: 95%;
    display: flex;
    justify-content: center;
    background: white;
    align-items: center;
    z-index: 1;
    opacity: 1;
}
.link-export{
  color: #00bcd4;
}
.link-export:hover{
  color: #00bcd4;
  text-decoration: underline;
  cursor: pointer;
}
</style>
